<script lang="ts">
import {globalToast} from "$lib/stores/toast.js";
import {ArrowsRepeatOutline, CirclePlusSolid, ParagraphSolid, PenSolid, TrashBinSolid} from "flowbite-svelte-icons";
import {Button, Dropdown, DropdownItem, Heading} from "flowbite-svelte";
import {page} from "$app/stores";
import EmployeeUploadModal from "$lib/partials/employee/EmployeeUploadModal.svelte";
import {createEventDispatcher} from "svelte";


    export let fotos: any[]
let dispatch = createEventDispatcher();
let uploadModal = false;
</script>

<div class="h-full flex flex-col">
    <Button size="sm" outline pill on:click={() => uploadModal = true}>
        <CirclePlusSolid class="pr-1"/>
        Dokument
    </Button>

</div>
<EmployeeUploadModal on:uploaded={(img) => dispatch('update', img.detail)} bind:open={uploadModal} employee={$page.data.employee} accept="image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"/>